import React from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import { QRCodeCanvas } from "qrcode.react";
import { getcolor } from "./UnderHeader";

const UnderHeaderT = (props) => {

  const { found, inv, sta, locInv, premiApp } = props;
  const clasm = useInvMain();
  const clas = useInvAF();
  const invColors = sta?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  const styfCenter = { fontWeight: "bold", maxHeight: "1rem", minHeight: "1rem", color: premiApp.billTemplate === 24 ? "#000" : "#7f0101" };

  const styleSq = {
    backgroundColor: premiApp.billTemplate === 24 ? secondColor : "#f5ebdb ",
    color: premiApp.billTemplate === 24 ? "#000" : "#7f0101",
  }

  return (
    <Grid
      item
      container
      style={{
        fontWeight: "bold", fontFamily: "Amiri-Regular",
        marginLeft: "0cm", marginRight: "0rem", paddingTop: "0.1rem"
      }}

    >
      <Grid item xs={12}>

        <Grid item container >
          <Grid item container style={{ direction: "rtl" }}>
            <Grid item xs={3} style={{ fontFamily: "Amiri-Regular" }}
            >
              <Grid item container className={clasm.mincntr}>
                <Grid item xs={12} >
                  {locInv.ProcTypeInvProc !== "22" && locInv.ProcTypeInvProc !== "03" && locInv.ProcTypeInvProc !== "04" &&
                 
                    (
                      <Grid item xs={12}>
                        {(locInv?.Step_inv2 && inv?.ZatcaQR) ? (
                          <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                            {
                              <QRCodeCanvas value={inv?.ZatcaQR} />
                            }

                          </ButtonBase>
                        )
                          : (
                            <ButtonBase
                              style={{ border: "solid 1px" }}
                            >
                              {
                                <img
                                  src={`data:image/jpeg;base64,${inv.qr_image}`}
                                  style={{ height: 120, width: 120, margin: 0, padding: 0 }}
                                  alt={found.nameA}
                                />
                              }
                            </ButtonBase>
                          )}

                      </Grid>)}
                </Grid>

              </Grid>
            </Grid>
            <Grid item xs={9}

            >
              <Grid item container className={clasm.mincntr}>
                <Grid item container style={{ paddingBottom: "0.3rem" }}>
                  {locInv.ProcTypeInvProc !== "22" &&  inv.tax>0 && (
                    <Grid item xs={6} className={clas.BdytitleHedQ2} style={styleSq}
                    >
                      {locInv.ProcTypeInvProc === "03" ? "QUOTATION" : sta.tot.tax_no_cust === ""
                        ? "فاتورة ضريبية مبسطة" + " " + "Simplified Tax Invoice"
                        : "فاتورة ضريبية" + " " + "Tax Invoice"}
                    </Grid>)}
                 
                  <Grid item xs={6}
                    className={clas.BdytitleHedQ2} style={styleSq}
                  >
                    {premiApp.billTemplate === 21 ?
                      (
                        locInv.invN
                      ) : (
                        locInv.invN +
                        " " +
                        // sta.tot.inv_type_name +
                        " " +
                        sta.tot.pay_type_name
                      )}
                  </Grid>
                </Grid>
                <Grid item container style={{ paddingTop: "0.5rem" }}>
                  <Grid container item xs={12}>
                    <Grid container item xs={6}>
                      <Grid item xs={3} style={{
                        borderBottom: "solid 0.1px",
                        borderRight: "solid 0.1px",
                        borderTop: "solid 0.1px",
                        textAlign: "right",
                        paddingRight: "0.6rem"
                      }}>
                        {txtA.invNumr}
                      </Grid>
                      <Grid item xs={6} style={{
                        borderBottom: "solid 0.1px",
                        borderTop: "solid 0.1px",

                      }}>
                        <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.id}</Paper>
                      </Grid>
                      <Grid item xs={3} style={{
                        borderBottom: "solid 0.1px",
                        borderTop: "solid 0.1px",
                        borderLeft: "solid 0.1px",
                        textAlign: "left",
                        paddingLeft: "0.6rem"
                      }}>
                        {/* {txtE.invNumr} */}
                        {"Inv No"}
                      </Grid>
                    </Grid>
                    <Grid container item xs={6}>
                      <Grid item xs={3} className={clas.BdyborBtR} style={{
                        borderBottom: "solid 0.1px",
                        borderRight: "solid 0.1px",
                        borderTop: "solid 0.1px",
                        textAlign: "right",
                        paddingRight: "0.6rem"
                      }}>
                        {"رقم الطلب"}
                      </Grid>
                      <Grid item xs={6} style={{
                        borderBottom: "solid 0.1px",
                        borderTop: "solid 0.1px",

                      }}>
                        <Paper className={clasm.minclr} style={styfCenter}>{sta.tot.refno}</Paper>
                      </Grid>
                      <Grid item xs={3} className={clas.BdyborBtL} style={{
                        borderBottom: "solid 0.1px",
                        borderTop: "solid 0.1px",
                        borderLeft: "solid 0.1px",
                        textAlign: "left",
                        paddingLeft: "0.6rem"
                      }}>
                        {"Order No"}
                      </Grid>
                    </Grid>

                  </Grid>

                  <Grid item xs={3} className={clas.BdyborBtR}
                    style={{
                      textAlign: "right",
                      paddingRight: "0.6rem"
                    }}>
                    {txtA.invDate}
                  </Grid>
                  <Grid item xs={6} className={clasm.minborB} >
                    <Paper className={clasm.minclr} style={styfCenter}>
                      {moment(sta.tot.date).format("YYYY/MM/DD")}
                    </Paper>
                  </Grid>
                  <Grid item xs={3} className={clas.BdyborBtL} style={{
                    textAlign: "left",
                    paddingLeft: "0.6rem"
                  }}>
                    {txtE.invDate}
                  </Grid>

                  <Grid container item xs={12}>

                    <Grid container item xs={6}>
                      <Grid item xs={4} className={clas.BdyborBtR} style={{
                        textAlign: "right",
                        paddingRight: "0.6rem"
                      }}>
                        {"تاريخ التوريد"}
                      </Grid>
                      <Grid item xs={4} className={clasm.minborB}>
                        <Paper className={clasm.minclr} style={styfCenter}>
                          {sta.tot?.Delivery_date === null ? moment(sta.tot.date).format("YYYY/MM/DD") :
                            moment(sta.tot.Delivery_date).format("YYYY/MM/DD")}
                        </Paper>
                      </Grid>
                      <Grid item xs={4} className={clas.BdyborBtL} style={{
                        textAlign: "left",
                        paddingLeft: "0.1rem"
                      }}>
                        {"Delivery Date"}
                      </Grid>
                    </Grid>
                    <Grid container item xs={6}>
                      <Grid item xs={3} className={clas.BdyborBtR}
                        style={{ textAlign: "right", paddingRight: "0.6rem" }}> {"المندوب"} </Grid>
                      <Grid item xs={6} className={clasm.minborB}>
                        <Paper className={clasm.minclr} style={styfCenter}>  {sta?.tot?.salesmen_name} </Paper>
                      </Grid>
                      <Grid item xs={3} className={clas.BdyborBtL}
                        style={{ textAlign: "left", paddingLeft: "0.6rem" }}> {"Salesmen"} </Grid>
                    </Grid>
                  </Grid>

                  {/* <Grid container item xs={12}>

                    <Grid container item xs={6}>
                      <Grid item xs={4} className={clas.BdyborBtR}
                        style={{ textAlign: "right", paddingRight: "0.6rem" }}> {"جوال العميل"} </Grid>
                      <Grid item xs={4} className={clasm.minborB}>
                        <Paper className={clasm.minclr} style={styfCenter}> {sta?.tot?.cust_mobile}</Paper>
                      </Grid>
                      <Grid item xs={4} className={clas.BdyborBtL}
                        style={{ textAlign: "left", paddingLeft: "0.1rem" }}>  {"Cust No"}  </Grid>
                    </Grid>

                  </Grid> */}

                  <Grid container item xs={12}>
                    <Grid item xs={3} className={clas.BdyborBtR}
                      style={{ textAlign: "right", paddingRight: "0.6rem" }}> {txtA.custAddress} </Grid>
                    <Grid item xs={6} className={clasm.minborB}>
                      <Paper className={clasm.minclr} style={styfCenter}>  {sta?.tot?.cust_address + "  -   " + sta?.tot?.cust_mobile} </Paper>
                    </Grid>
                    <Grid item xs={3} className={clas.BdyborBtL}
                      style={{ textAlign: "left", paddingLeft: "0.6rem" }}> {txtE.custAddress} </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UnderHeaderT;
